import { render, staticRenderFns } from "./PsychologyAttachmentViewer.vue?vue&type=template&id=c02fa0bc&scoped=true"
import script from "./PsychologyAttachmentViewer.vue?vue&type=script&lang=js"
export * from "./PsychologyAttachmentViewer.vue?vue&type=script&lang=js"
import style0 from "./PsychologyAttachmentViewer.vue?vue&type=style&index=0&id=c02fa0bc&prod&scoped=true&lang=css"
import style1 from "./PsychologyAttachmentViewer.vue?vue&type=style&index=1&id=c02fa0bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02fa0bc",
  null
  
)

export default component.exports